module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"staff_review":"管理员评论","my_review":"我的评论"}}')
  delete Component.options._Ctor
}
